<template>
    <div id="vocationalContainer">
        <div id="vocationalWrapper">
            <div id="vocTitle">
                <p>核心业务</p>
                <div>
                    <router-link to="/product?id=0" tag="span">了解更多业务产品 ></router-link>
                </div>
            </div>
            <div id="vocCont">
                <ul>
                    <li>
                        <div class="vocIco">
                            <img src="../../assets/imgs/home/icon/voc4.png">
                            <p>智慧供水</p>
                        </div>
                        <div class="vocText">
                            <div>
                                <p>智慧供水</p>
                                <span class="vocLine"></span>
                            </div>
                            <div class="vocDetailed">
                                基于水力模型等技术，搭建“水务物联网”，建设水务大数据中心，对供水系统进行有效的监控和管理
                            </div>
                        </div>  
                    </li>
                    <li>
                        <div class="vocIco">
                            <img src="../../assets/imgs/home/icon/voc1.png">
                            <p>智慧排水</p>
                        </div>
                        <div class="vocText">
                            <div>
                                <p>智慧排水</p>
                                <span class="vocLine"></span>
                            </div>
                            <div class="vocDetailed">
                                随着“互联网+”模式的发展，给排水系统实时监测与模型构建已经成为智慧水务的必由之路与先决条件
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="vocIco">
                            <img src="../../assets/imgs/home/icon/voc2.png">
                            <p>管道清洁</p>
                        </div>
                        <div class="vocText">
                            <div>
                                <p>管道清洁</p>
                                <span class="vocLine"></span>
                            </div>
                            <div class="vocDetailed">
                                节水型的纯绿色的冲洗方法，单次冲洗长度、管径及规模均达到国内领先水平。
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="vocIco">
                            <img src="../../assets/imgs/home/icon/voc3.png">
                            <p>水锤防护</p>
                        </div>
                        <div class="vocText">
                            <div>
                                <p>水锤防护</p>
                                <span class="vocLine"></span>
                            </div>
                            <div class="vocDetailed">
                                通过水力瞬变流模拟分析，提出阀门启闭方案、附属设施布置方案和通水方案等各种水锤防护预案，保障供水安全。
                            </div>
                        </div>
                    </li>
                    
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen5',
}
</script>

<style scoped>
    #vocationalContainer{
        background:#f4f4f4;
        padding: 40px 0;
    }
    #vocationalWrapper{
        width: 1120px;
        margin: 0 auto;
    }
    #vocTitle{
        margin-bottom: 60px;
    }
    #vocTitle>p{
        font-size: 21px;
        font-weight: bold;
        text-align: center;
    }
    #vocTitle>div{
        font-size: 12px;
        color: #026fd3;
        text-align: center;
        line-height: 30px;
    }
    #vocTitle>div>span{
        cursor: pointer;
    }
    #vocCont ul{
        border: 1px solid #ddd;
        border-right: 0;
        height: 183px;
    }
    #vocCont li{
        float: left;
        width: calc(25% - 1px );
        height: 183px;
        text-align: center;
        border-right: 1px solid #ddd;
        cursor: pointer;
        display: flex;                      
        justify-content:center;           
        align-items:Center; 
        position: relative;
        background: #fff;
    }
    .vocIco{
        font-size: 16px;
        line-height: 30px;
    }
    .vocText{
        display: none;
        font-size: 14px;
        padding: 35px 45px 50px 45px;
        background: #f2f8ff;
        border: 1px solid #adcaf1;
        width: 213px;
        height: 123px;
        position: absolute;
    }
    .vocText p{
        font-size: 16px;
    }
    .vocLine{
        width: 40px;
        height: 2px;
        display: inline-block;
        background: #0061ee;
    }
    .vocDetailed{
        text-align: left;
        line-height: 22px;
        text-indent: 28px;
        margin-top: 15px;
    }
    #vocCont li:hover .vocIco{
        display: none;
    }
    #vocCont li:hover .vocText{
        display: block;
        z-index: 1;
    }
</style>
